import ApiError from '~/types/ApiError';

const MAX_RETRIES = 2;
// 502 is svc-contracting's "Salesforce refused this request"; 503 (Salesforce busy) is still retried.
const REJECTED_STATUSES = new Set([400, 403, 404, 502]);

// A rejected request fails the same way again, and each retry costs svc-contracting Salesforce calls.
export function retryUnlessRejected(failureCount: number, error: Error): boolean {
  if (error instanceof ApiError && error.status !== undefined && REJECTED_STATUSES.has(error.status)) {
    return false;
  }
  return failureCount < MAX_RETRIES;
}
